import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "MZANSI STOKVEL",
  description = "",
  keywords = "",
  image = "",
  url = "",
  type = "website",
  structuredData = null
}) => {
  const fullTitle = title.includes('MZANSI STOKVEL') ? title : `${title} | MZANSI STOKVEL`;
  const fullUrl = url.startsWith('http') ? url : `www.mazansisave.co.za`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="MZANSI STOKVEL" />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <link rel="canonical" href={fullUrl} />
      
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="MZANSI STOKVEL" />
      <meta property="og:locale" content="en_ZA" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@mzansistokvel" />
      <meta name="twitter:creator" content="@mzansistokvel" />
      
      <meta name="geo.region" content="ZA" />
      <meta name="geo.placename" content="South Africa" />
      <meta name="language" content="English" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;